import { Slide } from "packages/lesson/dist/@types";
import { component as componentWindTurbine, extraContent as extraContentWindTurbine } from "./components/wind-turbine";

import {
  component as componentElectricShaver,
  extraContent as extraContentElectricShaver,
} from "./components/electric-shaver";

import {
  component as componentClassicalMusic,
  extraContent as extraContentClassicalMusic,
} from "./components/classical-music";
import theory from "../../theory";

const principle: Slide = {
  description:
    "Three different sound excerpts with similar sound pressure level (SPL) are displayed below. Notice how the loudness (N5) values change with spectral energy distribution and how they correlate with your own loudness impression.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          items: [
            {
              name: "Wind turbine",
            },
            {
              name: "Classical music",
            },
            {
              name: "Electric shaver",
            },
          ],
          options: {},
        },
      ],
      extraContent: [extraContentWindTurbine, extraContentClassicalMusic, extraContentElectricShaver],
      components: [componentWindTurbine, componentClassicalMusic, componentElectricShaver],
    },
  },
};

export default principle;
